import { render, staticRenderFns } from "./EventCategoriesContainer.vue?vue&type=template&id=24feab62"
import script from "./EventCategoriesContainer.vue?vue&type=script&lang=js"
export * from "./EventCategoriesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports